import { getAlertCategory } from "./alertPresentation";

export const ALERT_COLORS = {
  fire: { dark: "#ff6268", light: "#b91c1c" },
  theft: { dark: "#fbbf24", light: "#936000" },
  fall: { dark: "#60a5fa", light: "#1d4ed8" },
  intrusion: { dark: "#c084fc", light: "#7e22ce" },
  crowd: { dark: "#22d3ee", light: "#007a8f" },
  person: { dark: "#22d3ee", light: "#007a8f" },
  vehicle: { dark: "#34d399", light: "#047857" },
  weapon: { dark: "#fb7185", light: "#be123c" },
  dwell: { dark: "#a3e635", light: "#4d7c0f" },
  heatmap: { dark: "#2dd4bf", light: "#0f766e" },
  other: { dark: "#a8b9cf", light: "#536170" },
};
export const DEFAULT_ALERT_VISUAL_SETTINGS = { enabled: true, intensity: "normal", durationSeconds: 3, muted: false, volume: 60, colors: {} };
export const isAlertColor = color => typeof color === "string" && /^#[0-9a-f]{6}$/i.test(color);
export const normalizeAlertVisualSettings = value => {
  const duration = Number(value?.durationSeconds);
  const colors = {};
  Object.keys(ALERT_COLORS).forEach(category => {
    if (isAlertColor(value?.colors?.[category])) colors[category] = value.colors[category].toLowerCase();
  });
  return {
    enabled: value?.enabled !== false,
    intensity: ["low", "normal", "high"].includes(value?.intensity) ? value.intensity : "normal",
    durationSeconds: Number.isFinite(duration) && duration >= 1 && duration <= 300 ? duration : 3,
    muted: value?.muted === true,
    volume: Number.isFinite(Number(value?.volume)) && Number(value?.volume) >= 0 && Number(value?.volume) <= 100 ? Number(value.volume) : 60,
    colors,
  };
};
export const alertVisualStorageKey = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return `absolluty.alertVisuals:${user.id || user.email || "local"}`;
  } catch { return "absolluty.alertVisuals:local"; }
};
export const getAlertAccent = (type, mode, settings = DEFAULT_ALERT_VISUAL_SETTINGS) => {
  const category = getAlertCategory(type);
  return settings.colors[category] || ALERT_COLORS[category][mode === "light" ? "light" : "dark"];
};
export const alertAccentSx = color => ({ color, bgcolor: `${color}1f`, border: `1px solid ${color}66` });
